import Enquiry_Form_Modal from '../../enquiry_form_modal/Enquiry_Form_Modal';
import Icon from '../../../components/ui/AppIcon';
import { useState } from 'react';

const SolutionComparison = () => {
  const traditionalMBA = [
    { text: 'Requires 2-year career break', icon: 'XMarkIcon', color: 'text-error' },
    { text: 'High fees: ₹10-25 lakhs', icon: 'XMarkIcon', color: 'text-error' },
    { text: 'Fixed class schedules', icon: 'XMarkIcon', color: 'text-error' },
    { text: 'Relocation required', icon: 'XMarkIcon', color: 'text-error' },
    { text: 'Loss of income for 2 years', icon: 'XMarkIcon', color: 'text-error' },
  ];

  const onlineMBA = [
    { text: 'Study while working full-time', icon: 'CheckIcon', color: 'text-success' },
    { text: 'Affordable: ₹1.89 lakhs total', icon: 'CheckIcon', color: 'text-success' },
    { text: 'Learn at your own pace', icon: 'CheckIcon', color: 'text-success' },
    { text: 'Study from anywhere', icon: 'CheckIcon', color: 'text-success' },
    { text: 'Continue earning while learning', icon: 'CheckIcon', color: 'text-success' },
  ];

   const [showStickyModal, setShowStickyModal] = useState(false);

  return (
    <section className="py-20 bg-muted">
      <div className="max-w-content mx-auto px-section-margin">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-text-primary mb-4">
            Why Choose Online MBA Over Traditional MBA?
          </h2>
          <p className="text-lg text-text-secondary max-w-3xl mx-auto">
            Compare the flexibility and affordability of our Online MBA with traditional programs
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-8">
          {/* Traditional MBA */}
          <div className="bg-background rounded-xl p-8 border-2 border-error/20">
            <div className="flex items-center space-x-3 mb-6">
              <div className="w-12 h-12 bg-error/10 rounded-lg flex items-center justify-center">
                <Icon name="XCircleIcon" size={28} className="text-error" variant="solid" />
              </div>
              <h3 className="text-2xl font-bold text-text-primary">Traditional MBA</h3>
            </div>
            <div className="space-y-4">
              {traditionalMBA.map((item, index) => (
                <div key={index} className="flex items-start space-x-3">
                  <Icon name={item.icon as any} size={20} className={item.color} variant="solid" />
                  <span className="text-text-secondary">{item.text}</span>
                </div>
              ))}
            </div>
            <div className="mt-6 pt-6 border-t border-border">
              <div className="text-sm text-text-secondary">Total Investment</div>
              <div className="text-2xl font-bold text-error mt-1">₹10-25 Lakhs + 2 Years Income Loss</div>
            </div>
          </div>

          {/* Online MBA */}
          <div className="bg-gradient-to-br from-success/5 to-primary/5 rounded-xl p-8 border-2 border-success shadow-xl">
            <div className="flex items-center space-x-3 mb-6">
              <div className="w-12 h-12 bg-success rounded-lg flex items-center justify-center">
                <Icon name="CheckCircleIcon" size={28} className="text-success-foreground" variant="solid" />
              </div>
              <h3 className="text-2xl font-bold text-text-primary">D.Y. Patil Online MBA</h3>
            </div>
            <div className="space-y-4">
              {onlineMBA.map((item, index) => (
                <div key={index} className="flex items-start space-x-3">
                  <Icon name={item.icon as any} size={20} className={item.color} variant="solid" />
                  <span className="text-text-primary font-medium">{item.text}</span>
                </div>
              ))}
            </div>
            <div className="mt-6 pt-6 border-t border-success/20">
              <div className="text-sm text-text-secondary">Total Investment</div>
              <div className="text-2xl font-bold text-success mt-1">₹1.89 Lakhs (No Cost EMI Available)</div>
            </div>
            <button className="w-full mt-6 bg-accent text-accent-foreground py-4 rounded-lg font-bold shadow-cta hover:bg-accent/90 transition-default" onClick={() => {setShowStickyModal(true)}}>
              Choose Smart - Apply Now
            </button>
          </div>
        </div>
      </div>

        <Enquiry_Form_Modal
          show={showStickyModal}
          onHide={() => {
            setShowStickyModal(false);
          }}
        />
    </section>
  );
};

export default SolutionComparison;